import { setScrollTrigger } from "./parts/settings/gsap/scrolltrigger";
import { elms } from "./parts/vars/elms";
import { resize, SESSION_KEY_SCROLL_TOP_AFTER_BREAKPOINT_RELOAD } from "./parts/utils/resize";
import { setResize } from "./parts/utils/set-resize";
import { scroll } from "./parts/utils/scroll";
import { updateSvgScale } from "./parts/utils/svg-scale";
import { ham } from "./parts/components/common/ham";
import { header } from "./parts/components/common/header";
import { marquee } from "./parts/components/common/marquee";
import { storyMarquee } from "./parts/components/top/story-marquee";
import { para } from "./parts/components/common/para";
import { scrollIn } from "./parts/components/common/scrollIn";
import { tabs } from "./parts/components/common/tabs";
import { accordion } from "./parts/components/common/accordion";
import { followToc } from "./parts/components/common/article-grid";
import { peoplePager } from "./parts/components/common/people-pager";
import { copyright } from "./parts/components/common/copyright";
import { scrollTo } from "./parts/components/common/scrollTo";
import { slider } from "./parts/components/common/slider";
import { topMv } from "./parts/components/top/mv";
import { mvClipOpen } from "./parts/components/top/mv-clip";
import { mvContentReveal } from "./parts/components/top/mv-reveal";
import { mvImagesSlider } from "./parts/components/top/mv-slider";
import { whatCloudSlider } from "./parts/components/top/what-cloud-slider";
import { actionsSlider } from "./parts/components/top/actions-slider";
import { peopleSlider } from "./parts/components/top/people-slider";
import { peopleImageSlider } from "./parts/components/top/people-image-slider";
import { restartMarqueeGifs } from "./parts/components/top/mv-marquee-gif";
// microCMS連携のコラム機能（現状未使用。使う場合はコメントを外し main() 内の column() も有効化）
// import { column } from "./parts/components/top/column";
import { autoAddress } from "./parts/settings/autoAddress";
import { btnFixed } from "./parts/components/common/btn";
// import {twoDigits, addComma, inArray} from './lib/utils';
// {twoDigits, addComma, inArray}

if (sessionStorage.getItem(SESSION_KEY_SCROLL_TOP_AFTER_BREAKPOINT_RELOAD)) {
  sessionStorage.removeItem(SESSION_KEY_SCROLL_TOP_AFTER_BREAKPOINT_RELOAD);
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }
  window.scrollTo(0, 0);
  requestAnimationFrame(() => {
    window.scrollTo(0, 0);
  });
}

const userAgent = navigator.userAgent.toLowerCase();
const isMobile = /iphone|ipod|ipad|android/.test(userAgent);
const bodyClass = isMobile ? "mobile" : "pc";
document.body.classList.add(bodyClass);

const disableTelLinksOnPc = (): void => {
  if (isMobile) return;
  const telLinks = document.querySelectorAll<HTMLAnchorElement>('a[href^="tel:"]');
  telLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
    });
  });
};

let initialized: boolean = false;

setTimeout(() => {
  init();
}, 3000);

window.addEventListener("load", () => {
  init();
});

const init = (): void => {
  if (initialized) {
    return;
  }

  initialized = true;
  document.querySelector("body")?.classList.add("init");

  disableTelLinksOnPc();

  if (elms.ham) ham();
  if (elms.header) header();
  scrollTo();
  topMv();
  mvClipOpen();
  mvContentReveal();
  mvImagesSlider();
  whatCloudSlider();
  actionsSlider();
  peopleSlider();
  peopleImageSlider();
  restartMarqueeGifs();
  // column(); // microCMS連携のコラム機能（現状未使用）
  marquee();
  storyMarquee();
  para();
  scrollIn();
  tabs();
  accordion();
  followToc();
  peoplePager();
  copyright();
  slider();
  setScrollTrigger();
  resize();
  // Initial SVG scaling
  updateSvgScale();
  setResize();
  scroll();
  autoAddress();
  btnFixed();
  document.querySelector("body")?.classList.add("is-initialized");
  console.log("init");
};
